interface Logger {
    debug(message: string, data?: any): void;
    info(message: string, data?: any): void;
    warn(message: string, data?: any): void;
    error(message: string, data?: any): void;
  }
  
  export const logger: Logger = {
    debug: (message, data) => {
      if (process.env.NODE_ENV === 'development') {
        console.debug(`[DEBUG] ${message}`, data);
      }
    },
    info: (message, data) => {
      console.info(`[INFO] ${message}`, data);
    },
    warn: (message, data) => {
      console.warn(`[WARN] ${message}`, data);
    },
    error: (message, data) => {
      console.error(`[ERROR] ${message}`, data);
    },
  };